import * as React from "react";

import Typography from "@mui/material/Typography";

import ForYouPageUpsellImg from "@app/analytics/assets/fyp_upsell.png";
import UpsellModule, {
  UpsellModuleTitle,
  UpsellModuleThumbnail,
} from "@app/analytics/components/UpsellModule";
import type { UseForYouTeaser } from "@app/analytics/MeetingReports/hooks/useForYouTeaser";
import type { PulseResult } from "@app/analytics/Pulse/types";
import { ForYouIcon } from "@app/common/assets/icons";
import ROUTES from "@app/common/routes";

import IconBackground from "@rui/IconBackground";
import { ClampedTypography } from "@rui/styles";

const ForYouTitleIcon = () => (
  <IconBackground height={24} bgcolor="avatar.yellowGreen.main">
    <ForYouIcon sx={{ color: "avatar.yellowGreen.dark" }} />
  </IconBackground>
);

const ForYouTeaser = ({
  result,
  onDismiss,
}: {
  result: PulseResult;
  onDismiss: (id: string) => void;
}) => {
  const handleDismiss = () => onDismiss(result.id);

  return (
    <UpsellModule
      cta={{ label: "View For You", to: ROUTES.FOR_YOU }}
      color="#E1F2C433"
      img={
        result.thumbnailUrl ? (
          <UpsellModuleThumbnail src={result.thumbnailUrl} />
        ) : undefined
      }
      onDismiss={handleDismiss}
    >
      <UpsellModuleTitle Icon={<ForYouTitleIcon />}>
        New Topics Discovered
      </UpsellModuleTitle>
      <ClampedTypography
        variant="labelReg"
        maxLines={3}
        color="shades.neutral.600"
      >
        {result.summary}
      </ClampedTypography>
    </UpsellModule>
  );
};

const ForYouUpsell = ({ onDismiss }: { onDismiss: () => void }) => (
  <UpsellModule
    cta={{ label: "Add Read", to: ROUTES.CALENDAR_UPCOMING }}
    color="#E1F2C433"
    onDismiss={onDismiss}
    img={<UpsellModuleThumbnail src={ForYouPageUpsellImg} />}
  >
    <UpsellModuleTitle Icon={<ForYouTitleIcon />}>
      Topics For You
    </UpsellModuleTitle>
    <Typography variant="labelReg" color="shades.neutral.600">
      Add Read to a meeting to start building your For You Page with key topics,
      action items, and questions!
    </Typography>
  </UpsellModule>
);

const ForYouTeaserGate = ({
  shouldUpsell,
  result,
  onDismissTeaser,
  onDismissUpsell,
}: UseForYouTeaser) => {
  if (shouldUpsell) {
    return <ForYouUpsell onDismiss={onDismissUpsell} />;
  }

  if (result) {
    return <ForYouTeaser result={result} onDismiss={onDismissTeaser} />;
  }

  return null;
};

export default ForYouTeaserGate;
